import { NavigationControllerFactory } from '@accedo/spatial-nav';
import { logger, LoggingLevel } from '@accedo/logger';
import { DialogManager } from '@accedo/ctv-ui-dialog';

export const nav = NavigationControllerFactory.create({
  logging: false,
  loggingLevel: LoggingLevel.debug,
  enableMouseEvents: Boolean(process.env.MOUSE_ENABLED),
});
// @ts-expect-error For debugging
window.nimble.nav = nav;

let assignFocusTimeoutId: NodeJS.Timeout;

type OptionTryAssignFocus = {
  /** Delay before trying to assign focus. */
  delayInMs?: number;
  /** Number of attempts to try before failure. */
  retryAttempts?: number;
  /** Fallback id to try after max failed attempts. */
  fallbackId?: string;
  onDialog?: boolean;
};

export const tryAssignFocus = (id: string, options?: OptionTryAssignFocus, currentAttempt = 1): void => {
  const delayInMs = options?.delayInMs ?? 250;
  const retryAttempts = options?.retryAttempts ?? 3;
  const fallbackId = options?.fallbackId ?? 'content';
  const assignFocusOnDialog = options?.onDialog ?? false;

  clearTimeout(assignFocusTimeoutId);

  if (currentAttempt > retryAttempts) {
    logger.warn(`tryAssignFocus failed for ${id} assigning focus to first focusable node`);
    nav.assignFocus(options?.fallbackId || 'content');

    return;
  }
  assignFocusTimeoutId = setTimeout(() => {
    try {
      if (!DialogManager.isDialogOpen() || assignFocusOnDialog) {
        nav.assignFocus(id);
      }

      clearTimeout(assignFocusTimeoutId);
    } catch (err) {
      tryAssignFocus(
        id,
        {
          delayInMs,
          retryAttempts,
          fallbackId,
        },
        currentAttempt + 1,
      );
    }
  }, delayInMs);
};
